module.exports = __webpack_public_path__ + "img/stk-rest.62527424.png";